import React, { useState } from "react";
import styled from "@emotion/styled";
import { Button, Form, Select, Modal } from "antd";
import { EditOutlined, LeftOutlined } from "@ant-design/icons";
import UITable from "../../../Reusablecomponents/UITable/UITable.js";
import Editicon from "../../../assets/images/Editicon.svg";
import { useNavigate } from "react-router-dom";

const Container = styled.div`
  .container_editicon {
    background-color: white;
    border: 1px solid lightblue;
    padding: 9px;
    border-radius: 50%;
  }
  background: #f8f9fa;
  padding: 24px;
  /* font-family:
    -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif; */
`;

const Header = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
`;

const TitleSection = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  h2 {
    margin: 0;
    font-size: 19px;
    color: #1a1a1a;
    font-weight: 500;
  }
  .status-tag {
    color: #faad14;
    font-weight: 500;
  }
`;

const BackButton = styled(Button)`
  background: #eaf8f0;
  color: #2e7d32;
  border: none;
  &:hover {
    background: #d4f0e0 !important;
    color: #2e7d32 !important;
  }
`;

const DetailCard = styled.div`
  background: #ffffff;
  border-radius: 8px;
  padding: 24px;
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 24px 16px;
  border: 1px solid #f0f0f0;
`;

const DataField = styled.div`
  display: flex;
  flex-direction: column;
  gap: 6px;
  .label {
    color: #8c9ba5;
    font-size: 17px;
  }
  .value {
    color: #2d3748;
    font-size: 15px;
    font-weight: 400;
  }
`;

const LogContainer = styled.div`
  background: #ffffff;
  padding: 24px;
  border-radius: 8px;
  margin-top: 24px;

  h3 {
    margin-bottom: 16px;
    font-size: 16px;
    color: #1f2937;
    font-weight: 500;
  }
`;

const FormContainer = styled.div`
  background: #ffffff;
  font-family: -apple-system, BlinkMacSystemFont, sans-serif;
`;

const FormHeader = styled.div`
  padding-bottom: 16px;
  border-bottom: 1px solid #f0f0f0;
  display: flex;
  justify-content: space-between;
  align-items: center;
  h3 {
    margin: 0;
    font-size: 16px;
    color: #1f2937;
  }
  .close-icon {
    cursor: pointer;
    color: #9ca3af;
    font-size: 18px;
  }
`;

const StyledForm = styled(Form)`
  padding-top: 24px;

  .ant-form-item-label > label {
    color: #718096 !important;
    font-size: 13px;
  }

  .ant-select-selector {
    border-radius: 20px !important;
    height: 40px !important;
    display: flex;
    align-items: center;
  }
`;

const ActionRow = styled.div`
  display: flex;
  justify-content: flex-end;
  gap: 12px;
  margin-top: 40px;
  border-top: 1px solid #f0f0f0;
  padding-top: 16px;
`;

const CancelButton = styled(Button)`
  background-color: #eafaf1;
  color: #2e7d32;
  border: none;
  border-radius: 20px;
  padding: 0 24px;
  height: 40px;
  &:hover {
    background-color: #d4f5e2 !important;
    color: #2e7d32 !important;
  }
`;

const CreateButton = styled(Button)`
  background-color: #2e7d32;
  color: #ffffff;
  border: none;
  border-radius: 20px;
  padding: 0 24px;
  height: 40px;
  &:hover {
    background-color: #236125 !important;
    color: #ffffff !important;
  }
`;

const columns = [
  {
    title: "Service Date",
    dataIndex: "serviceDate",
    key: "serviceDate",
  },
  {
    title: "ODO (Kms)",
    dataIndex: "odoKms",
    key: "odoKms",
  },
];

const dataSource = [
  { key: "1", serviceDate: "20th Feb 2025", odoKms: "22455" },
  { key: "2", serviceDate: "20th Feb 2025", odoKms: "22455" },
  { key: "3", serviceDate: "20th Feb 2025", odoKms: "22455" },
  { key: "4", serviceDate: "20th Feb 2025", odoKms: "22455" },
  { key: "5", serviceDate: "20th Feb 2025", odoKms: "22455" },
];

// --- Component Definition ---

const ServiceDetails = () => {
  const [showEditForm, setShowEditForm] = useState(false);
  const [form] = Form.useForm();

  const onFinish = (values) => {
    console.log("Submitted values: ", values);
    setShowEditForm(false);
  };

  const handleClose = () => {
    setShowEditForm(false);
  };

  const detailsData = [
    { label: "Vehicle No", value: "KA12345" },
    { label: "Vehicle Type", value: "Truck" },
    { label: "Model", value: "Axes 100" },
    { label: "Mfg Year", value: "1970" },
    { label: "Internal Dimension of truck", value: "20/20/20" },
    { label: "Cubic Capacity", value: "10,000" },
    { label: "Maximum Load Capacity (in Kg)", value: "20,000" },
    { label: "Fuel Type", value: "Diesel" },
    { label: "Tonnes", value: "-/-" },
    { label: "Link to", value: "-/-" },
    { label: "Status", value: "Active" },
    { label: "Mileage", value: "80" },
    { label: "ODO Reset on", value: "-/-" },
    { label: "Registration Date", value: "24th Aug 2024" },
    { label: "Chassis Number", value: "-/-" },
    { label: "Engine Number", value: "-/-" },
    { label: "Transmission", value: "Manual" },
    { label: "Entity", value: "-/-" },
    { label: "Supplier", value: "-/-" },
    { label: "Driver", value: "-/-" },
    { label: "Office", value: "GCS HQ" },
    { label: "Service Interval (Kms)", value: "4000" },
    { label: "Last Service", value: "-/-" },
    { label: "Service Reminder Threshold", value: "-/-" },
  ];

  const navigate = useNavigate();

  return (
    <>
      <Container>
        <Header>
          <TitleSection>
            <BackButton
              onClick={() => navigate("/Workshop")}
              shape="circle"
              icon={<LeftOutlined />}
            />
            <h2>
              Service - KA12345 <span className="status-tag">Due Soon</span>
            </h2>
          </TitleSection>
          <div style={{ display: "flex", gap: "10px", alignItems: "center" }}>
            <Button
              type="primary"
              shape="round"
              style={{ background: "#a6a6a6", border: "none", width: "130px" }}
            >
              Serviced
            </Button>
            <div className="container_editicon">
              <img
                src={Editicon}
                onClick={() => setShowEditForm(true)}
                alt="Editicon"
              />
            </div>
          </div>
        </Header>

        <DetailCard>
          {detailsData.map((item, index) => (
            <DataField key={index}>
              <span className="label">{item.label}</span>
              <span className="value">{item.value}</span>
            </DataField>
          ))}
        </DetailCard>
      </Container>

      <LogContainer>
        <h3>Service Logs</h3>
        <UITable
          columns={columns}
          dataSource={dataSource}
          pagination={false}
          scroll={{ y: 300 }}
        />
      </LogContainer>

      <Modal
        open={showEditForm}
        onCancel={handleClose}
        footer={null}
        closable={false}
        destroyOnClose
        width={1300}
      >
        <FormContainer>
          <FormHeader>
            <h3>Edit Service</h3>
            <span className="close-icon" onClick={handleClose}>
              ✕
            </span>
          </FormHeader>

          <StyledForm
            form={form}
            layout="vertical"
            onFinish={onFinish}
            initialValues={{
              serviceInterval: "4000",
              lastService: "20/20/20",
              reminderThreshold: "2000",
            }}
          >
            <div
              style={{
                display: "grid",
                gridTemplateColumns: "repeat(3, 1fr)",
                gap: "16px",
              }}
            >
              <Form.Item
                label="Service Interval (Kms)"
                name="serviceInterval"
                rules={[
                  { required: true, message: "Please select an interval" },
                ]}
              >
                <Select options={[{ value: "4000", label: "4000" }]} />
              </Form.Item>

              <Form.Item label="Last service" name="lastService">
                <Select options={[{ value: "20/20/20", label: "20/20/20" }]} />
              </Form.Item>

              <Form.Item
                label="Service Reminder Threshold"
                name="reminderThreshold"
              >
                <Select options={[{ value: "2000", label: "2000" }]} />
              </Form.Item>
            </div>

            <ActionRow>
              <CancelButton onClick={handleClose}>Cancel</CancelButton>
              <CreateButton htmlType="submit">Create</CreateButton>
            </ActionRow>
          </StyledForm>
        </FormContainer>
      </Modal>
    </>
  );
};

export default ServiceDetails;
